// extracted by mini-css-extract-plugin
module.exports = {"datepicker":"date-picker-module--datepicker--2BztV"};